import React, {useLayoutEffect, useMemo, useReducer, useRef} from 'react'
import PageLayout from '../../../components/layout/PageLayout'
import {postUploadImage} from '../../../apis/image/postUploadImage'
import Text from '../../../components/text/Text'
import UnderLineInput from '../../../components/input/UnderLineInput'
import DateInput from '../../../components/input/DateInput'
import WizButton from '../../../components/button/WizButton'
import {useSearchParams} from 'react-router-dom'
import useQueryEventDetail from '../../../hooks/api/event/useQueryEventDetail'
import {useTime} from '../../../utils/time'
import useNavigation from '../../../hooks/useNavigation'
import WizImage from '../../../components/image/WizImage'
import {updateEvent} from '../../../apis/event/updateEvent'
import WizSelectButton from '../../../components/button/WizSelectButton'
import ic_check_primary from '../../../assets/images/ic_check_primary.png'
import ic_arrow_right from '../../../assets/images/ic_arrow_right.png'
import img_placeholder from '../../../assets/images/placeholder.png'

interface IProps {
    className?: string
}

const initState = {
    name: '',
    language: '',
    thumbnail: '',
    new_thumbnail: '',
    url: '',
    start_at: '',
    end_at: '',
    show_on_account_page: false,
    background_color: [],
}

const EventDetailPage: React.FC<IProps> = ({className}) => {
    const [searchParams] = useSearchParams(document.location.search)
    const eventId = searchParams.get('id')
    const {data} = useQueryEventDetail(eventId)

    const {convertInputToTimezone, convertTimezoneToInput} = useTime()
    const {goEvent} = useNavigation()

    const [state, dispatch] = useReducer(reducer, initState)
    const {name, language, thumbnail, url, new_thumbnail, start_at, end_at, show_on_account_page, background_color} =
        state

    useLayoutEffect(() => {
        dispatch({type: 'field_reset'})
    }, [data])

    function reducer(state, action) {
        switch (action.type) {
            case 'field_reset':
                return {
                    name: data?.name,
                    start_at: (convertTimezoneToInput(data?.start_at) as string) || undefined,
                    end_at: (convertTimezoneToInput(data?.end_at) as string) || undefined,
                    thumbnail: data?.thumbnail,
                    new_thumbnail: data?.new_thumbnail || '',
                    language: data?.language,
                    url: data?.url,
                    show_on_account_page: data?.show_on_account_page ?? false,
                    background_color: data?.background_color ?? [],
                }
            case 'field_update':
                return {...state, [action.field]: action.value}
        }
        return {...state}
    }

    const thumbnailRef = useRef<any>()
    const newThumbnailRef = useRef<any>()
    const languageList = useMemo(() => {
        return [
            {id: 'ko', value: 'Korean'},
            {id: 'en', value: 'English'},
        ]
    }, [])

    const onChangeImage = async (e, field) => {
        const imageFile = e?.target?.files[0]

        if (imageFile) {
            const result = await postUploadImage(imageFile)
            dispatch({
                type: 'field_update',
                field: field,
                value: result?.image_url,
            })
        }
    }

    const onClickCreateEvent = async () => {
        if (language === '') {
            alert('언어를 선택해주세요')
            return false
        }

        const {data} = await updateEvent(eventId, {
            name: name,
            thumbnail: thumbnail,
            new_thumbnail: new_thumbnail || '',
            show_on_account_page: show_on_account_page,
            url: url,
            language: language,
            start_at: (convertInputToTimezone(start_at) as string) || null,
            end_at: (convertInputToTimezone(end_at) as string) || null,
            background_color: background_color,
        })

        if (data?.success) {
            alert('Edit Event Complete')
            goEvent()
        }
    }

    return (
        <PageLayout title={'Edit Event'}>
            <div
                className={
                    'w-[1000px] bg-white rounded-[10px] shadow-normal mx-auto py-[40px] px-[80px] grid grid-cols-2 gap-x-[40px] gap-y-[60px] lg:w-[900px] md:w-[520px] md:px-[40px] sm:w-full sm:block sm:space-y-[30px]'
                }>
                <div className={'col-span-2 w-[50%] mx-auto'}>
                    <div className={'mx-auto md:w-[300px] sm:w-[200px]'}>
                        <Text className={'text-body3 text-font02'}>Event Thumbnail</Text>
                        <div
                            onClick={() => newThumbnailRef?.current?.click()}
                            className={
                                'relative border border-line02 rounded-[5px] overflow-hidden w-full min-h-[196px] max-h-[196px] mt-[10px] cursor-pointer lg:min-h-[139px] sm:min-h-[92px]'
                            }>
                            {new_thumbnail ? (
                                <WizImage
                                    src={`${new_thumbnail?.split('?')?.at(0)}?type=webp&width=1920`}
                                    className={'w-full'}
                                />
                            ) : (
                                <div className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] w-[50px]">
                                    <WizImage src={img_placeholder} className="w-full h-auto rounded-[5px]" />
                                </div>
                            )}
                        </div>
                        <input
                            type={'file'}
                            onChange={e => onChangeImage(e, 'new_thumbnail')}
                            ref={newThumbnailRef}
                            className={'hidden'}
                        />
                    </div>
                    {/* <div className={'ml-[30px]'}>
                        <Text className={'text-body3 text-font02'}>Background Color</Text>
                        <div className={'mt-[10px]'}>
                            <div
                                style={
                                    background_color?.at(0) && background_color?.at(1)
                                        ? {
                                              backgroundImage: `linear-gradient(to right, ${background_color?.at(
                                                  0,
                                              )}, ${background_color?.at(1)})`,
                                          }
                                        : {
                                              backgroundColor:
                                                  background_color?.at(0) || background_color?.at(1) || '#FFFFFF',
                                          }
                                }
                                className={`border border-line02 rounded-[5px] overflow-hidden w-full min-h-[80px] relative`}></div>
                        </div>
                        <div className={'flex items-center gap-[30px] mt-[20px]'}>
                            <div>
                                <Text className={'text-body3 text-font02'}>Gradation From </Text>
                                <UnderLineInput
                                    value={background_color?.at(0)}
                                    placeholder="#FFFFFF"
                                    onChanged={text => {
                                        const newArr = [background_color?.at(0) || '', background_color?.at(1) || '']
                                        newArr[0] = text
                                        dispatch({
                                            type: 'field_update',
                                            field: 'background_color',
                                            value: newArr,
                                        })
                                    }}
                                />
                            </div>
                            <WizImage src={ic_arrow_right} />
                            <div>
                                <Text className={'text-body3 text-font02'}>Gradation To </Text>
                                <UnderLineInput
                                    value={background_color?.at(1)}
                                    placeholder="#FFFFFF"
                                    onChanged={text => {
                                        const newArr = [background_color?.at(0) || '', background_color?.at(1) || '']
                                        newArr[1] = text
                                        dispatch({
                                            type: 'field_update',
                                            field: 'background_color',
                                            value: newArr,
                                        })
                                    }}
                                />
                            </div>
                        </div>
                    </div> */}
                </div>

                <div className={'col-span-2'}>
                    <div
                        onClick={() => {
                            dispatch({
                                type: 'field_update',
                                field: 'show_on_account_page',
                                value: !show_on_account_page,
                            })
                        }}
                        className={'flex items-center gap-x-[5px] justify-center  cursor-pointer '}>
                        <div
                            className={`w-[20px] h-[20px] border rounded-[5px] ${
                                show_on_account_page ? 'border-primary' : 'border-font04'
                            }`}>
                            {show_on_account_page && <WizImage src={ic_check_primary} />}
                        </div>
                        <Text className={'text-body3 text-font02'}>Used Leaderboard Top / Account Page</Text>
                    </div>
                    {show_on_account_page && (
                        <div className={'mx-auto w-[320px] mt-[20px]'}>
                            <Text className={'text-body3 text-font02'}>Banner Image</Text>
                            <div
                                onClick={() => thumbnailRef?.current?.click()}
                                className={
                                    'relative border border-line02 rounded-[5px] overflow-hidden min-h-[65px] h-auto mt-[10px] cursor-pointer'
                                }>
                                {thumbnail ? (
                                    <WizImage
                                        src={`${thumbnail?.split('?')?.at(0)}?type=webp&width=1920`}
                                        className={'w-full'}
                                    />
                                ) : (
                                    <div className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] w-[30px]">
                                        <WizImage src={img_placeholder} className="w-full h-auto rounded-[5px]" />
                                    </div>
                                )}
                            </div>
                            <input
                                type={'file'}
                                onChange={e => onChangeImage(e, 'thumbnail')}
                                ref={thumbnailRef}
                                className={'hidden'}
                            />
                        </div>
                    )}
                </div>

                <div>
                    <Text className={'text-body3 text-font02'}>Title</Text>
                    <UnderLineInput
                        value={name}
                        onChanged={text => dispatch({type: 'field_update', field: 'name', value: text})}
                    />
                </div>

                <div>
                    <Text className={'text-body3 text-font02'}>Event Url</Text>
                    <UnderLineInput
                        value={url}
                        onChanged={text => dispatch({type: 'field_update', field: 'url', value: text})}
                    />
                </div>

                <div
                    className={
                        'col-span-2 grid grid-cols-3 gap-x-[40px] items-center md:grid-cols-2 md:gap-y-[60px] sm:block sm:space-y-[30px]'
                    }>
                    <div className={'sm:text-center'}>
                        <Text className={'text-body3 text-font02'}>Start At</Text>
                        <DateInput
                            value={start_at}
                            onChange={e => {
                                dispatch({
                                    type: 'field_update',
                                    field: 'start_at',
                                    value: e.target.value,
                                })
                            }}
                            className={'sm:mx-auto'}
                        />

                        <Text
                            className={'text-primary text-ti3 pt-[5px] underline cursor-pointer'}
                            onClick={() =>
                                dispatch({type: 'field_update', field: 'start_at', value: '0000-00-00T00:00'})
                            }>
                            Reset TimeStamp
                        </Text>
                    </div>
                    <div className={'sm:text-center'}>
                        <Text className={'text-body3 text-font02'}>End At</Text>
                        <DateInput
                            value={end_at}
                            onChange={e =>
                                dispatch({
                                    type: 'field_update',
                                    field: 'end_at',
                                    value: e.target.value,
                                })
                            }
                            className={'sm:mx-auto'}
                        />
                        <Text
                            className={'text-primary text-ti3 pt-[5px] underline cursor-pointer'}
                            onClick={() =>
                                dispatch({type: 'field_update', field: 'end_at', value: '0000-00-00T00:00'})
                            }>
                            Reset TimeStamp
                        </Text>
                    </div>

                    <div className={'space-y-[5px] md:col-span-2 md:text-center'}>
                        <Text className={'text-body3 text-font02'}>Channel</Text>
                        <WizSelectButton
                            onChange={e => dispatch({type: 'field_update', field: 'language', value: e.id})}
                            data={languageList}
                            activeValue={languageList?.find(list => list.id === language)}
                            className={'md:mx-auto'}
                        />
                    </div>
                </div>

                <div className={'col-span-2 text-center mt-[30px]'}>
                    <WizButton type={'blue'} size={'big'} text={'Edit Event'} onClick={() => onClickCreateEvent()} />
                </div>
            </div>
        </PageLayout>
    )
}
export default EventDetailPage
